import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("maqam_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve a media path to an absolute URL (handles remote URLs and uploaded files).
const withToken = (url) => {
  const token = localStorage.getItem("maqam_token");
  return token ? `${url}${url.includes("?") ? "&" : "?"}t=${encodeURIComponent(token)}` : url;
};

export const guideUrl = (path) => withToken(`${API}/guide/${path}`);

export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return u.startsWith("/api/") ? withToken(`${BACKEND_URL}${u}`) : `${BACKEND_URL}${u}`;
};
